// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getEventList, IEventListParams, IEventListResponse } from "@vanmeter/App/Services/EventListService";

type HandlerType = HandlerWithResult<IEventListParams, IEventListResponse>;

export const DispatchBeginLoading: HandlerType = props => {
    props.dispatch({
        type: "xEventList/BeginLoading",
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.result = await getEventList(props.parameter);
    } catch (error) {
        logger.error(error);
        props.dispatch({
            type: "xEventList/Faild",
        });
        return false;
    }
};

export const DispatchCompleteLoadEventList: HandlerType = props => {
    props.dispatch({
        type: "xEventList/CompleteLoading",
        parameter: props.parameter,
        events: props.result.result,
    });
};

export const chain = [DispatchBeginLoading, RequestDataFromApi, DispatchCompleteLoadEventList];

const loadEvents = createHandlerChainRunner(chain, "loadEvents");
export default loadEvents;
